/* Movatic WMS — Mobile Receive | CesarFilho 932048016 */
export default function Receive() {
    return (
        <div className="py-3 grid gap-3">
            <div className="card p-3">
                <div className="font-semibold">Recebimento</div>
                <div className="text-sm text-neutral-500 mt-1">
                    Escaneie a nota/OC, leia os itens e confirme. (Fluxo guiado virá aqui)
                </div>
            </div>
        </div>
    )
}
